//@import dependencies
import React, { CSSProperties, ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @import redux
import { sidebarMenuSelected, expand } from 'app_events/app/actions'
// @end

//@import components
import IconComponent from 'app_components/commons/icons'
//@end

// @INFO Import services
import { routingService } from 'app_services/routingService'
// @end

// @import types
import {IMenuItem} from 'app_types/components/sidebar/sidebarTypes'
// @end

// @INFO Import Styles
import './../sidebarComponentStyle.scss'
import { CgMenuRound } from 'react-icons/cg'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import useWindowWidth from 'app_hooks/useWindowWidth'

// @ADD Component types
interface ISidebarModuleLayoutProps {
  menu: IMenuItem[]
  app?: any
  imageNavbarSrc: any
  imageNavbarAlt: string
  className?: string
  style?: CSSProperties
  hideOnClose?: boolean
  extraItems?: ReactElement[]
}

const MOBILE_BREAKPOINT = 800

const SidebarLayout: React.FC<ISidebarModuleLayoutProps> = (props) => {

  const [colors] = useColors()

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { windowWidth } = useWindowWidth()

  function handleClick(menu: any) {
    return dispatch(sidebarMenuSelected({ selected: menu.id }))
  }

  const changeSidebarStatus = () => {
    dispatch(expand(!props?.app?.sidebar?.collapse))
  }

  const hideSidebarClass = useMemo(() => {
    const collapse = props?.app?.sidebar?.collapse
    const hideOnClose = props.hideOnClose
    if (hideOnClose && !collapse) {
      return 'hide-on-close'
    } else {
      return ''
    }
  }, [props.hideOnClose, props?.app?.sidebar?.collapse])

  return (
    <div
      className={`sidebar ${props?.app?.sidebar?.collapse ? 'sidebar-unrolled' : ''} ${props.className ? props.className : ''} ${hideSidebarClass}`}
      style={props.style}
      id={windowWidth && windowWidth > MOBILE_BREAKPOINT ? "menu" : undefined}
    >
      <div className='wrapper'>
        <div className='menu' >
          <div className="menu-header" id={windowWidth && windowWidth <= MOBILE_BREAKPOINT ? "menu" : undefined}>

              {props?.app?.sidebar?.collapse || props.hideOnClose ? (
                <div className="menu-logo">
                  <div onClick={() => changeSidebarStatus()}>
                    <div className="menu-logo-close">
                      <IconComponent svg="Close" width={32} color={colors.text} />
                    </div>
                  </div>
                  <Link to={routingService.getSecurePath()}>
                    <img src={props.imageNavbarSrc} alt={props.imageNavbarAlt} />
                  </Link>
                </div>
              ) : (
                <div onClick={() => changeSidebarStatus()}>
                  <div className="menu-button">
                    <CgMenuRound
                      color='white'
                      fontSize={32}
                    />
                  </div>
                </div>
              )}
          </div>
          <div className={`menu-links  ${props?.app?.sidebar?.collapse ? 'menu-links-unrolled' : ''}`}>
            {props.menu &&
              props.menu.filter((menu: IMenuItem) => menu.show).map((menu: IMenuItem, index: number) => {
                return (
                  <Link
                    id={menu.id}
                    key={index}
                    to={{
                      pathname: menu.disabled ? '#' : (menu.newTab ? menu.url : routingService.getSecurePath(menu.url))
                    }}
                    target={menu.newTab ? '_blank' : undefined}
                  >
                    <OverlayTrigger
                      trigger={['hover', 'click', 'focus']}
                      placement='right'
                      overlay={
                        <Tooltip id='toolip-channel'>
                          {t(`components.${menu.translation}`)}
                        </Tooltip>
                      }>
                      <div onClick={menu.disabled ? undefined : () => handleClick(menu)} className={`link ${props?.app?.sidebar?.selected === menu?.id ? 'link-selected' : ''} ${menu.disabled ? 'menu-disabled' : ''}`}>
                        <div className='link-icon'>
                          <IconComponent
                            svg={menu.icon ? menu.icon : undefined}
                            component={menu.component ? menu.component : undefined}
                            class_name={`menu-icon ${menu.class_name}`}
                            color={colors.text}
                            width={(menu.icon_size) ? menu.icon_size : null}
                          />
                        </div>
                        {props?.app?.sidebar?.collapse ?
                        <div>
                          <TextComponent
                            type='text'
                            className='link-span'
                            style={{
                              color: 'white',
                              textTransform: 'uppercase',
                              fontWeight: 300
                            }}
                          >
                            {t(`components.${menu.translation}`)}
                          </TextComponent>
                          <TextComponent
                            type='text'
                            className='link-span'
                            style={{
                              color: 'white',
                              fontSize: '0.8rem',
                              fontWeight: 300
                            }}
                          >
                            {menu.description}
                          </TextComponent>
                        </div>
                        :null}
                      </div>
                    </OverlayTrigger>
                  </Link>
                )
              })}
            {props.extraItems?.map((item, idx) => (
              <div key={idx} style={{ width: '100%' }}>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStatesToProps = (state: any) => {
  return state
}

export default connect(mapStatesToProps)(SidebarLayout)
